import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import { NavigationStart, Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { HelperService } from '../../services/helper.service';
import { RolePermissionType } from 'src/app/constants/role-permission-type';
import { getExostarDetails, getNavLinks, hasPermission } from 'src/app/constants/role-permision-submenu';
import { TourHelperService } from '../../services/tour.helper.service';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { Location, NgClass } from '@angular/common';
import { getRoleContext, tabIndex, userRoleContext } from 'src/app/constants/role-details.constants';
import { buyerInfo } from 'src/app/constants/buyer_info';
import { BreadcrumbsComponent } from 'src/app/modules/breadcrumbs/breadcrumbs.component';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-main-tabs',
    templateUrl: './main-tabs.component.html',
    styleUrls: ['./main-tabs.component.scss'],
    standalone: true,
    imports: [BreadcrumbsComponent, NgClass, ExtendedModule, MatIconModule, MatTabsModule, MatTooltipModule, FlexModule, RouterLinkActive, RouterLink, TourAnchorMatMenuDirective, RouterOutlet]
})

export class MainTabsComponent implements OnInit, OnChanges, OnDestroy {
    private router = inject(Router);
    private helperService = inject(HelperService);
    private tourHelperService = inject(TourHelperService);
    private generalService = inject(GeneralService);
    private location = inject(Location);

    @Input() selectedIndex: any;
    navLinks: any[] = [];
    isMenuExpanded: boolean = true;
    buyerInfo: any;
    DeepLinkURL = '';
    currentSelectedLinkIndex: number = 0;
    exostarDetails: any[] = []
    userInfo: any
    tourService: any;
    hasAccessToFormLifeCycle: boolean = false;
    userRolecontext = userRoleContext;
    currentRoleContext = getRoleContext();
    featureDetails: any = {};
    appVersion: any;
    appName: any;
    constructor() {
        let userData = sessionStorage.getItem('loggedInUserDetails')
        if (userData) {
            this.userInfo = JSON.parse(userData)
        }
        this.hasAccessToFormLifeCycle = hasPermission(this.userInfo, RolePermissionType.CreateNewForms) || hasPermission(this.userInfo, RolePermissionType.ModifyForms) || hasPermission(this.userInfo, RolePermissionType.Deployments);
        this.exostarDetails = getExostarDetails(this.userInfo);
    }
    ngOnDestroy(): void {
        sessionStorage.setItem('selectedTabIndex', '0');
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.changeTab();
    }
    toggleLeftMenu() {
        this.isMenuExpanded = !this.isMenuExpanded;
    }

    toggleTree(link: any) {
        link.isExpanded = !link.isExpanded;
    }

    showTour(index: number) {
        // Supplier nav items use supplierTabIndex values that overlap with Buyer's tabIndex.
        // No guided tours are defined for Supplier routes; help text is provided via
        // matTooltip on the icon instead. Guard here to prevent the wrong Buyer tour
        // from being triggered when a Supplier clicks the help icon.
        if (this.currentRoleContext === userRoleContext.Supplier) {
            return;
        }
        if (this.currentSelectedLinkIndex == index) {
            switch (index) {
                case tabIndex.home:
                case tabIndex.dashboard:
                    /** start tour for home/dashboard page */
                    this.tourHelperService.initHomeTour();
                    this.tourService = this.tourHelperService.getTourService();
                    this.tourService.start();
                    break;
                case tabIndex.suppliers:
                    /*Start tour for Search suppliers */
                    this.tourHelperService.initSearchSupplierTourService();
                    this.tourService = this.tourHelperService.getTourService();
                    this.tourService.start();
                    break;
                case tabIndex.campaigns:
                    /*Start tour for Campaign */
                    this.tourHelperService.initNewCampaignTourService();
                    this.tourService = this.tourHelperService.getTourService();
                    this.tourService.start();
                    break;
                case tabIndex.groups:
                    /*Start tour for New Group */
                    this.tourHelperService.initNewGroupTour();
                    this.tourService = this.tourHelperService.getTourService();
                    this.tourHelperService.setIsTourStartedIndicator(true);
                    this.tourService.start();
                    break;
                case tabIndex.administration:
                case tabIndex.enrollments:
                case tabIndex.formManagement:
                case tabIndex.reports:
                default:
                    /* there is no tour to start, so just stop */
                    break;
            }
        }
    }

    ngOnInit(): void {
        // The app-relative URL the browser actually loaded (e.g. on a hard reload).
        // Location.path() strips the configured <base href> (e.g. "/obmui/"), so this
        // works regardless of how the app is hosted. Used to decide whether to send the
        // user to the default landing page or keep them on the deep-linked page they
        // reloaded into.
        const reloadedPath = this.location.path().split('?')[0].split('#')[0];
        const isLandingEntry = reloadedPath === '' || reloadedPath === '/' || reloadedPath === '/home' || reloadedPath === '/dashboard';

        if( this.currentRoleContext === userRoleContext.Buyer ) {
            this.helperService.getSettingValueByKey('AppVersion').subscribe((appVersion: any) => {
            this.appVersion = appVersion.data
        })
        this.helperService.getSettingValueByKey('DefaultApplicationName').subscribe((appName: any) => {
            this.appName = appName.data
        })
        }
        
        this.DeepLinkURL = window.location.origin;
        this.helperService.getBuyerId().subscribe((res: any) => {
            this.buyerInfo = res;
            buyerInfo.hostOrganizationUUID = res.hostOrganizationUUID;
            buyerInfo.userID = res.userID;
            buyerInfo.CurrentUserUPN = res.currentUserUPN ? res.currentUserUPN : '';
            buyerInfo.CurrentUserEmail = res.currentUserEmail ? res.currentUserEmail : '',
            buyerInfo.CurrentUserOrgName = res.currentUserOrgName || '';
            buyerInfo.CurrentUserFirstName = res.currentUserFirstName ? res.currentUserFirstName : '';
            buyerInfo.FormServicesUrl = res.formServicesUrl || res.FormServicesUrl || '';
            buyerInfo.CurrentUserLastName = res.currentUserLastName ? res.currentUserLastName : '';
            buyerInfo.ExternalSourceName = res.externalSourceName ? res.externalSourceName : '';
            buyerInfo.SpAppName = res.appName ? res.appName : '';
            buyerInfo.CampaignMicroserviceUrl = res.campaignMicroserviceUrl ? res.campaignMicroserviceUrl : '';
            buyerInfo.IsBulkUserUploadCampaignEnabled = res.isBulkUserUploadCampaignEnabled || 'false';
            buyerInfo.BulkUserUploadCampaignMicorserviceUrl = res.bulkUserUploadCampaignMicorserviceUrl || '';
            buyerInfo.IsCampaignEnabled = res.isCampaignEnabled || 'false';
            buyerInfo.IsGroupEnabled = res.isGroupEnabled || 'false';
            buyerInfo.reportingToolUrl = res.reportingToolUrl || '';
            buyerInfo.MagUrl = res.magUrl || '';
            buyerInfo.FormsAPIToken = res.formsAPIToken || res.FormsAPIToken || '';
            buyerInfo.FormAPIAppID = res.formAPIAppID || res.FormAPIAppID || '';

            if ((res.isCampaignEnabled && (res.isCampaignEnabled === 'false')) && (res.isBulkUserUploadCampaignEnabled && (res.isBulkUserUploadCampaignEnabled === 'false'))) {
                const campaignIndex = this.navLinks.findIndex((link) => link.label === 'Campaigns');
                this.navLinks.splice(campaignIndex, 1);
            }
            if (res.isGroupEnabled && (res.isGroupEnabled === 'false')) {
                const groupsIndex = this.navLinks.findIndex((link) => link.label === 'Groups');
                this.navLinks.splice(groupsIndex, 1);
            }
        });
        if (this.currentRoleContext === userRoleContext.Buyer) {
            this.generalService.getBuyerFeatureList().subscribe((featureDetails: any) => {
                this.generalService.setBuyerFeatureDetails(featureDetails);
                this.featureDetails = this.generalService.getBuyerFeatureDetails();
                this.navLinks = getNavLinks(this.userInfo, this.hasAccessToFormLifeCycle, this.featureDetails);
                // Only redirect to the default landing page when entering at the
                // root/landing URL. On a reload of a deep-linked page, keep the user there.
                if (isLandingEntry) {
                    if (this.featureDetails.NewDashboard) {
                        this.router.navigateByUrl('/dashboard');
                    } else {
                        this.router.navigateByUrl('/home');
                    }
                }
            });
        } else  {
            this.navLinks = getNavLinks(this.userInfo, this.hasAccessToFormLifeCycle);
        }
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart && this.currentRoleContext === userRoleContext.Buyer) {
                const currentLink = this.navLinks.find((link) => {
                    return event.url.includes(link.link);
                });
                sessionStorage.setItem('selectedTabIndex', currentLink?.index?.toString());
                this.changeTab()
            }
        });
        (window as any).changeTab = this.changeTab.bind(this);
        this.changeTab();
    }

    changeTab() {
        this.currentSelectedLinkIndex = parseInt(sessionStorage.getItem('selectedTabIndex') || '0');
    }

    navigateToPage(link: any, event?: MouseEvent) {
        if (link.link == 'Buyer/FormWizard/SystemForms') {
            let message = {
                "action": "REDIRECT",
                "data": "/Buyer/FormWizard/SystemForms"
            }
            window.parent.postMessage(message, '*');
        }
        if (link.link == 'Buyer/Default/MainDashboard') {
            let message = {
                "action": "REDIRECT",
                "data": "/Buyer/Default/MainDashboard"
            }
            window.parent.postMessage(message, '*');
        }

        if (link.isLegacy) {
            // Prevent the browser from following the href within the iframe — navigation
            // must go through window.top so the full legacy app frame is replaced, not just
            // the Angular sub-frame. Without preventDefault, the iframe navigates to the
            // legacy page which re-embeds the Angular app, causing recursive rendering
            // (SM-3307: Reports page loads recursively inside the T&C iframe).
            event?.preventDefault();
            this.redirectToUrl(link.link);
            return;
        }

        // Handle external redirect (like Reports/ReportingTool)
        if (link.isExternalRedirect && link.externalUrl) {
            event?.preventDefault();
            // Use window.top to break out of the iframe in AppUpgrade environment
            const targetWindow = window.top ?? window;
            targetWindow.location.href = link.externalUrl;
            return;
        }

        sessionStorage.setItem('selectedTabIndex', link.index)
        this.changeTab();

    }

    redirectToUrl(path: string) {
        if (window.top) {
            // Normalize path to ensure it starts with '/' for proper URL construction
            const normalizedPath = path.startsWith('/') ? path : '/' + path;
            window.top.location.href = this.DeepLinkURL + normalizedPath;
        }
    }

    getAppInitials(appName: string): string {
    return appName
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase(); 
  }

    hasPermissionForSubMenu(link: any): boolean {
        return link.subMenu && link.subMenu.some((item: any) => item.hasPermission);
    }
}
